// extracted by mini-css-extract-plugin
export default {"icon":"pinCodeInput_icon__FP4DA","inputsWrapper":"pinCodeInput_inputsWrapper__ieqeA","input":"pinCodeInput_input__zTMyK","inputWithError":"pinCodeInput_inputWithError__ApWK+"};